"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSession = void 0;
const react_1 = require("react");
const context_1 = require("../context");
/**
 * Returns the session data from the SessionContext
 */
const useSession = () => react_1.useContext(context_1.SessionContext);
exports.useSession = useSession;
//# sourceMappingURL=use-session.js.map